module.exports = __webpack_public_path__ + "img/lo002.7a8ce662.jpg";